import { createFileRoute } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/departments",
)({
  staticData: {
    breadcrumb: [
      {
        label: "Workspace - Departments",
        href: "/settings/workspace/departments",
      },
    ],
  },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      "department:read",
      "/settings/workspace/general",
    ),
})
